/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

const customColors = {
  lightBlue: "#25a9df",
  blue: "#0387c8",
  darkBlue: "#1f78b4",
  greenBlue: "#2d95c0",
  lightPink: "#fbe1e6",
  pink: "#f7bfc9",
  darkPink: "#a5005f",
  lightGreen: "#46d3b1",
  green: "#00cd05",
  darkGreen: "#168b7b",
  purple: "#6a3d9a",
  lightPurple: "#bb9ddc",
  lightBlack: "#131313",
  blueBlack: "#080c11",
  inkBlack: "#17181d",
  lightGrey: "#f3f3f3",
  darkerGrey: "#d1d1d1",
  darkBlack: "#18181d",
  greenLight: "#e4ffd9",
  greenDefault: "#87d240",
  disabledGrey: "#858585",
  cerulean: "#0097d4",

  statisticsGrey2: "#f1f1f1",
  statisticsGrey3: "#e9e9e9",
  statisticsGrey4: "#e4e4e4",
  statisticsGrey5: "#d5d5d5",
};

export default customColors;
